import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { StrapiSlice } from './types';

const initialState: StrapiSlice = {
  closedTopBanners: [],
};

export const strapiSlice = createSlice({
  name: 'strapi',
  initialState,
  reducers: {
    closeTopBanner: (state, { payload: bannerID }: PayloadAction<string>) => {
      state.closedTopBanners.push(bannerID);
    },
  },
});

export const { closeTopBanner } = strapiSlice.actions;
